// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pDJl","question":"styles_question__13wLZ","description":"styles_description__2KXtg"};